import Vue from 'vue'
import { getAuth, onAuthStateChanged } from "firebase/auth";
import Router from 'vue-router'

//Empresas

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    //Dashboard
    {
      path: "/Dashboard",
      component: () => import('../views/Dashboard/Dashboard.vue'),
      children: [
        { path: "/Dashboard/Account/", component: () => import('../views/Dashboard/Account.vue') },
        { path: "/Dashboard/main", component: () => import('../views/Dashboard/main.vue') },
        { path: "/Dashboard/agents", component: () => import('../views/Dashboard/agents.vue')},
        { path: "/Dashboard/onboarding", component: () => import('../views/Dashboard/onboarding.vue')},

        { path: "/Dashboard/create_new", component: () => import('../views/Dashboard/createBot.vue')}, //NEW Version

        //Full Bot
        { path: "/Dashboard/v2/:id_chatbot", component: () => import('../views/Dashboard/fullBotV2.vue')},
        { path: "/Dashboard/edit/sources/:id_chatbot", component: () => import('../components/componentsDataSource/editTrainingDataComponent.vue')},

      ],
      meta: {
        requiresAuth: true
      }
    },

    //Login
    {
      path: '/login',
      name: 'login',
      component: () => import('../views/External/Login.vue')
    },
    //Password Recovery
    {
      path: '/PasswordRecovery',
      name: 'PasswordRecovery',
       component: () => import('../views/External/passwordRecovery.vue'),
    },
    {
      path: "/signup",
      name: "Register",
      component: () => import('../views/External/Register.vue'),
    }   
  ]
});


// ++++++++++++++++++++ Middleware antes que se ejecuten las solicitudes de las rutas +++++++++++++++++++++++
// router.beforeEach((to,from,next)=> {

//   if(to.matched.some(route => route.meta.requiresAuth)){
//     const auth = getAuth();
//     onAuthStateChanged(auth, (user) => {  // Metodo para verificar si hay usuario Logueado y dejalo pasar a la ruta (next())
//       if (user) {

//         if(user.emailVerified){
//           // console.log(user.emailVerified)
//           next();
//         }else{
//           next({
//             name: 'login'
//           })
//         }

//       } else {
//         next({
//           name: 'login'
//         })
//       }
//     });
//   }else{
//     next()
//   }

// })

// router.js

// router.js

router.beforeEach((to, from, next) => {
  // Verificamos si la ruta requiere autenticación
  if (to.matched.some(route => route.meta.requiresAuth)) {
    
    const auth = getAuth();
    
    // IMPORTANTE: onAuthStateChanged es un listener. 
    // Lo guardamos en 'unsubscribe' para cerrarlo después y no dejar procesos colgados.
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      unsubscribe(); // Cerramos el listener inmediatamente después de la primera verificación

      if (user) {
        // YA NO verificamos user.emailVerified aquí.
        // Si hay usuario, lo dejamos pasar a cualquier ruta protegida.
        next();
      } else {
        // Si no hay usuario, va para afuera.
        next({ name: 'login' });
      }
    });

  } else {
    // Si la ruta no requiere auth (ej. login, landing), pasa directo.
    next();
  }
});

export default router;